import { Spin } from 'antd';

import { Html5QrcodeScannerState } from 'html5-qrcode';

import styles from './styles.module.css';

type ScannerProps = {
  loading: boolean;
  scannerState: Html5QrcodeScannerState | null;
  restartScanner: () => void;
};

const Scanner = ({ loading, restartScanner, scannerState }: ScannerProps) => {
  return (
    <div className={styles.qrScannerContainer}>
      {loading && <Spin className={`${styles.container} ${styles.empty}`} />}
      <div id='qr-reader' className={styles.scanner}></div>
      {scannerState === Html5QrcodeScannerState.SCANNING && (
        <button className={styles.restartButton} onClick={restartScanner}>
          Reiniciar câmera
        </button>
      )}
    </div>
  );
};

export default Scanner;
